import React, { useState, useEffect } from 'react';
import { Button, TagInput } from 'components';
import { ResourcePicker } from '@shopify/app-bridge-react';
import { RESOURCE_PICKER_DEFAULT_REDUCERS } from 'lib/globals';
import useBindToContext from 'hooks/useBindToContext';

export function InitialSelectionIds(resourcesArray, pattern) {
    return resourcesArray.map(({ id }) => ({ id: pattern.replace('{id}', id) }));
}
const ShopifyResourcePicker = ({
    value,
    type = 'Product',
    children,
    onChange,
    reducer = false,
    allowMultiple = true,
    BindToContext = null,
    showVariants = false,
    initialSelectionIds,
    showHidden = false,
    verifySelection,
    initialQuery
}) => {
    const [isOpened, setIsOpen] = useState(false);
    const [BindedValue, BindedOnChange, _, onRender] = useBindToContext(
        BindToContext,
        value,
        onChange
    );
    const idFilterRegex = /gid:\/\/shopify\/.*\/([0-9]+)?.*/;
    const formatIds = (value) => {
        if (Array.isArray(value)) {
            return value.map((item) => {
                return formatIds(item);
            });
        } else if (value === Object(value)) {
            let outputObject = {};
            Object.keys(value).forEach((key) => {
                outputObject[key] = formatIds(value[key]);
            });
            return outputObject;
        } else if (typeof value === 'string') {
            const match = value.match(idFilterRegex);
            return match ? match[1] : value;
        }
        return value;
    };

    const onSelection = ({ selection }) => {
        setIsOpen(false);
        if (verifySelection && !verifySelection(selection)) {
            return;
        }
        let value = formatIds(selection.map(reducer || RESOURCE_PICKER_DEFAULT_REDUCERS[type]));
        if (!allowMultiple) return BindedOnChange(value[0]);
        let mergedItems = BindedValue.concat(value || []);
        let uniqueItems = mergedItems.reduce((acc, obj) => {
            const foundIndex = acc.findIndex((item) => item.id === obj.id);
            if (foundIndex === -1) {
                acc.push(obj);
            }
            return acc;
        }, []);
        BindedOnChange(uniqueItems);
    };

    const removeItem = (id) => {
        BindedOnChange(allowMultiple ? BindedValue.filter((item) => item.id != id) : null);
    };

    const tags = allowMultiple
        ? BindedValue
        : BindedValue && !!Object.keys(BindedValue).length
        ? [BindedValue]
        : [];

    //useEffect(() => {
    //if (onRender?.length) onRender.forEach(fn => fn());
    //}, [onRender]);

    return (
        <>
            <div>
                {/* pass trigger function to children */}
                {children(() => setIsOpen(true))}
                {!!tags.length && <TagInput tags={tags} close={(id) => removeItem(id)} />}
            </div>
            <ResourcePicker
                showVariants={showVariants}
                showHidden={showHidden}
                resourceType={type}
                initialSelectionIds={initialSelectionIds}
                open={isOpened}
                allowMultiple={allowMultiple}
                onSelection={onSelection}
                onCancel={() => setIsOpen(false)}
                initialQuery={initialQuery}
            />
        </>
    );
};

export default ShopifyResourcePicker;
